var _rect, _rect2, _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvgSuccessrate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 115,
    viewBox: "0 0 114 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    width: 114,
    height: 115,
    rx: 25,
    fill: "url(#paint0_linear_344_151)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 94,
    height: 95,
    rx: 20,
    fill: "url(#paint1_linear_344_151)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57 74.6666C66.2048 74.6666 73.6667 67.2047 73.6667 57.9999C73.6667 48.7952 66.2048 41.3333 57 41.3333C47.7953 41.3333 40.3334 48.7952 40.3334 57.9999C40.3334 67.2047 47.7953 74.6666 57 74.6666Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57 68C62.5228 68 67 63.5228 67 58C67 52.4772 62.5228 48 57 48C51.4772 48 47 52.4772 47 58C47 63.5228 51.4772 68 57 68Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57 61.3334C58.8409 61.3334 60.3333 59.841 60.3333 58.0001C60.3333 56.1591 58.8409 54.6667 57 54.6667C55.159 54.6667 53.6666 56.1591 53.6666 58.0001C53.6666 59.841 55.159 61.3334 57 61.3334Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_344_151",
    x1: 8.48936,
    y1: 5.44737,
    x2: 104.108,
    y2: 108.518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6401"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB3332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_344_151",
    x1: 17,
    y1: 14.5,
    x2: 96,
    y2: 99.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB3333"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvgSuccessrate);
export default __webpack_public_path__ + "static/media/AvgSuccessrate.9ab0f03c850d188a26de65dfef2990f1.svg";
export { ForwardRef as ReactComponent };